import { Page } from '@/core/architecture'

import { ArtistMembershipPurchaseProceedTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistMembershipPurchaseProceed Page
 * Implemented as a practical sample.
 */
export const ArtistMembershipPurchaseProceed: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistMembershipPurchaseProceedTemplate state={state} {...actions} />
}
